import { BooleanSearch, BooleanSearchActionListStyled, BooleanSearchInputWrap } from "@similarweb/ui-components";
import {
    booleanSearchToString,
    booleanSearchUrlToComponent,
    getFilterType,
} from "app/pages/website-analysis/traffic-sources/search/booleanSearchUtility";
import type React from "react";
import styled from "styled-components";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

export const BooleanSearchWrapper = styled.div`
    min-height: 42px;
    display: flex;
    ${BooleanSearchActionListStyled} {
        z-index: 9999;
        background-color: #fff;
    }
    ${BooleanSearchInputWrap} {
        min-width: 235px;
    }
    .boolean-search {
        width: 100%;
    }
`;

interface IBooleanSearchUtilityWrapperProps {
    shouldEncodeSearchString?: boolean;
    searchInputPlaceholder?: string;
    onChange?: (items) => void;
}
const onChipAdd = (item) => {
    allTrackers.dispatchTrackEvent(
        "Dynamic Filter",
        "click",
        `dynamic filter/${getFilterType(item) || ""}/${item.text || ""}`,
    );
};
const onChipRemove = (item) => {
    allTrackers.dispatchTrackEvent(
        "Dynamic Filter",
        "remove",
        `dynamic filter/${getFilterType(item) || ""}/${item.text || ""}`,
    );
};

export const BooleanSearchUtilityWrapper: React.FunctionComponent<IBooleanSearchUtilityWrapperProps> = (props) => {
    const { searchInputPlaceholder, shouldEncodeSearchString } = props;
    const { BooleanSearchTerms } = proNavigator.getParams();
    const chips = decodeURIComponent(booleanSearchUrlToComponent(BooleanSearchTerms));

    const onChange = (items) => {
        const newApiParams = proNavigator.getParams();
        const BooleanSearchTerms = booleanSearchToString(items, shouldEncodeSearchString);
        proNavigator.updateParams({ ...newApiParams, BooleanSearchTerms });
        if (typeof props.onChange === "function") {
            props.onChange(BooleanSearchTerms);
        }
    };
    return (
        <BooleanSearchWrapper>
            <BooleanSearch
                placeholder={searchInputPlaceholder}
                onChange={onChange}
                chips={chips}
                onChipRemove={onChipRemove}
                onChipAdd={onChipAdd}
            />
        </BooleanSearchWrapper>
    );
};
